import React, { FC, memo } from 'react';
import { Category } from '~/lib/data-contract';
import { CMSLink, CategoryCardMedia, CategoryCardText } from '~/shared/components';
import styles from './m20category.module.css';
import clsx from 'clsx';

type Props = {
    item: Category;
    isDarkShade: boolean;
    backgroundColor?: string;
    imageSizes: string;
};

const M20category: FC<Props> = memo(({ item, isDarkShade, backgroundColor, imageSizes }) => {
    const { image, callToAction, title, text } = item || {};
    const callToActionUrl = callToAction?.url;

    return (
        <CMSLink
            href={callToActionUrl}
            title={callToAction?.title || item?.title}
            className={clsx(styles.root, callToActionUrl && 'hover-effect-underline-center')}
        >
            <div className={styles.mediaWrapper}>
                <CategoryCardMedia image={image} video={item.video} imgSizes={imageSizes} is4by5 />
            </div>
            <CategoryCardText
                headline={title}
                text={text}
                backgroundColor={backgroundColor}
                isDarkShade={isDarkShade}
                withLink={Boolean(callToActionUrl)}
                titleAs="h3"
                className={styles.textBlock}
            />
        </CMSLink>
    );
});

M20category.displayName = 'M20category';

export default M20category;
